var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBalplads = function SvgBalplads(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.642 12.62c0 1.312-1.181 2.374-2.642 2.374s-2.642-1.062-2.642-2.374C5.358 10.702 8 8.315 8 8.315s2.642 2.271 2.642 4.305"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 1 5.852 5.156l-1.618-.804C3.03 5.793 2 7.608 2 9.608 2 12.588 4.685 15 8 15s6-2.413 6-5.392C13.993 5.008 8 1 8 1"
  })));
};
export default SvgBalplads;